export default {
  title: 'Dodaj partnera',
  mode: {
    single: 'Pojedynczy partner',
    bulk: 'Masowo (CSV)',
  },
  buttons: {
    send_invite: 'Wyślij zaproszenie',
  },
  bulk: {
    form: {
      file: {
        label: 'Lista partnerów (CSV)',
        hint: 'Jeden partner w wierszu. Wymagane kolumny: Email, Kraj firmy oraz Zarejestrowana nazwa firmy lub Nazwa firmy. Nazwa marki jest opcjonalna i staje się nazwą wyświetlaną konsumentom. Każdy wiersz jest weryfikowany przed utworzeniem.',
      },
    },
    buttons: {
      select_file: 'Wybierz plik CSV',
      download_template: 'Pobierz szablon importu',
      import: 'Importuj partnerów',
    },
    columns: {
      legal_name: 'Zarejestrowana nazwa firmy / Nazwa firmy',
      display_name: 'Nazwa marki',
      admin_email: 'E-mail',
      company_country: 'Kraj firmy',
    },
    errors: {
      title: 'Nie udało się zaimportować pliku.',
      nothing_imported: 'Nie utworzono żadnego partnera. Popraw powyższe wiersze i prześlij plik ponownie.',
      columns: {
        row: 'Wiersz',
        column: 'Kolumna',
        error: 'Błąd',
      },
    },
    toasts: {
      queued_one:
        '{{count}} partner w kolejce — zaproszenia są wysyłane po każdym utworzeniu. Otrzymasz e-mail podsumowujący po zakończeniu importu.',
      queued_few:
        '{{count}} partnerzy w kolejce — zaproszenia są wysyłane po utworzeniu każdego z nich. Po zakończeniu importu otrzymasz e-mail z podsumowaniem.',
      queued_many:
        '{{count}} partnerów w kolejce — zaproszenia są wysyłane po utworzeniu każdego z nich. Po zakończeniu importu otrzymasz e-mail z podsumowaniem.',
      queued_other:
        '{{count}} partnerów w kolejce — zaproszenia są wysyłane po każdym utworzeniu. Otrzymasz e-mail podsumowujący po zakończeniu importu.',
    },
    footnote:
      'Partnerzy są tworzeni pojedynczo w tle, z takim samym ustawieniem jak dla pojedynczego partnera: e-mail z zaproszeniem, subdomena panelu i domyślna domena sklepu. Kraj decyduje o walucie i strefie czasowej; stan można ustawić później w profilu partnera. Przetwarzanie płatności konfiguruje się później w zakładce Płatności partnera.',
  },
  form: {
    name: {
      label: 'Nazwa partnera',
    },
    admin_email: {
      label: 'E-mail admina (odbiorca zaproszenia)',
      hint: 'Wyślemy e-mail z zaproszeniem do założenia konta.',
    },
    display_name: {
      label: 'Nazwa widoczna dla klientów',
      hint: 'Etykieta „Powered by ___" widoczna dla klientów. Domyślnie przyjmuje nazwę partnera.',
    },
    region: {
      label: 'Kraj',
      placeholder: 'Wybierz kraj',
      hint: 'Ustawia walutę, strefę czasową i język zaproszenia partnera.',
      summary: 'Waluta {{currency}} · {{timezone}} · Język zaproszenia {{language}}',
      default_root: 'Domena sklepu: nowe marki są obsługiwane na {{host}}',
    },
    sub_region: {
      label: 'Stan',
      placeholder: 'Cały kraj',
      hint: 'Opcjonalnie — pozostaw puste, aby zastosować dla całego kraju.',
    },
    language: {
      label: 'Język zaproszenia',
      placeholder: '{{language}} (domyślny)',
      hint: 'Opcjonalnie — domyślnie główny język kraju.',
    },
  },
  footnote: 'Ustawienia brandingu i zarobków można skonfigurować po akceptacji zaproszenia przez partnera.',
  toasts: {
    created: 'Partner utworzony — e-mail z zaproszeniem jest w drodze.',
  },
};
